/**
 * Custom handler
 *
 * Listens to ViewportFlexItems event and adjusts the bottom margin of the sidebar menu
 * so that it doesn't clash with the sidebar footer.
 */
const SidebarMenuHandler = {
  enable() {
    document.addEventListener('viewport-flex-item:refreshed', e => {
      const eventData = e.detail;

      // We just want to listen to changes to the sidebar footer
      if ( !eventData.el.classList.contains('js-nav-sidebar-footer') ) {
        return;
      }

      const sidebarNavEl = document.querySelector('.js-nav-sidebar-menu-container');
      const sidebarFooterHeight = parseInt( document.querySelector('.js-nav-sidebar-footer').offsetHeight );
      const sidebarFooterPositionChangedAmount = parseInt( eventData.el.getAttribute('data-pos-change-amount') );

      let originalMarginBottom = sidebarNavEl.getAttribute('data-init-margin') !== null
        ? parseInt( sidebarNavEl.getAttribute('data-init-margin') )
        : 0
      ;

      // Stores original margin bottom as data attribute
      if ( originalMarginBottom === 0 ) {
        sidebarNavEl.setAttribute('data-init-margin', sidebarFooterHeight);
        originalMarginBottom = sidebarFooterHeight;
      }

      // When the viewport is in full height, the original margin should be applied (as is on desktop devices)
      if ( eventData.hasViewportGrown ) {
        sidebarNavEl.style.marginBottom = originalMarginBottom + 'px';
      }
      // But if the viewport is smaller, then we increase the bottom margin by how much the sidebar footer's
      // position changed.
      else {
        sidebarNavEl.style.marginBottom = (originalMarginBottom + sidebarFooterPositionChangedAmount) + 'px';
      }
    });
  }
};

export default SidebarMenuHandler;
